
define('modules/application/wizard/classes/exportSolutionMaterialList',[
    "app",

    // Libs
    "backbone",

    //Classes
    "./exportElement"

  ],

  function(app, Backbone, exportElement) {

    var exportSolutionMaterialList = {};

    exportSolutionMaterialList.generateReport = function() {
      var that = this,
        dataToSend = {},
        k = 0,
        i = 0,
        grandTotal = 0,
        dataProvider = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider"),
        addDownloadView = function(pdfUrl) {
          var loaderView = BticinoS4B.Instances.Views.headerView.loaderPopup;
          var title = loaderView.$el.find(".header p");
          var that = this;

          loaderView.$el.find(".content").fadeOut("100", function() {
            var content = loaderView.$el.find(".content");
            content.html("");
            content.append("<a data-bypass target=\"_blank\" href=\"" + pdfUrl + "\" class=\"download-button dataBypass\"><button class=\"orange-button\">Download</button></a>");
            content.fadeIn("100");
            content.find(".download-button").bind("click", function(e) {
              e.preventDefault();
              loaderView.hide();
              window.open(pdfUrl);
            });
          });

          title.fadeOut("100", function() {
            title.text($.i18n._("IDS_W1_9096"));
            title.fadeIn("100", function() {
              $.colorbox.resize();
            });
          });
        },

        addItemListByPackageExternalItems = function(externalItems) {
          if (dataToSend.itemListByPackage.externalItems.section) {
            for (i = 0; i < externalItems.data.length; i++) {
              dataToSend.itemListByPackage.externalItems.data.push(externalItems.data[i]);
            }
          } else {
            dataToSend.itemListByPackage.externalItems = externalItems;
          }
        },

        addItemListByPackageAutomaticItems = function(automaticItems) {
          if (dataToSend.itemListByPackage.automaticItems.section) {
            for (i = 0; i < automaticItems.data.length; i++) {
              dataToSend.itemListByPackage.automaticItems.data.push(automaticItems.data[i]);
            }
          } else {
            dataToSend.itemListByPackage.automaticItems = automaticItems;
          }
        },

        addItemListByPackageOptionalItems = function(optionalItems) {
          if (dataToSend.itemListByPackage.optionalItems.section) {
            for (i = 0; i < optionalItems.data.length; i++) {
              dataToSend.itemListByPackage.optionalItems.data.push(optionalItems.data[i]);
            }
          } else {
            dataToSend.itemListByPackage.optionalItems = optionalItems;
          }
        },

        addItemListByPackageZones = function(zones) {
          if (dataToSend.itemListByPackage.zones.length) {
            for (i = 0; i < zones.length; i++) {
              dataToSend.itemListByPackage.zones.push(zones[i]);
            }
          } else
            dataToSend.itemListByPackage.zones = zones;
        },

        addItemListByProductInPriceList = function(items) {
          var itemInserted = false;
          for (i = 0; i < items.length; i++) {
            for (j = 0; j < dataToSend.itemListByProduct.productInPriceList.items.length; j++) {
              itemInserted = false;
              if (dataToSend.itemListByProduct.productInPriceList.items[j].productCode == items[i].productCode) {
                itemInserted = true;
                dataToSend.itemListByProduct.productInPriceList.items[j].quantity = dataToSend.itemListByProduct.productInPriceList.items[j].quantity + items[i].quantity;
                dataToSend.itemListByProduct.productInPriceList.items[j].amount = (dataToSend.itemListByProduct.productInPriceList.items[j].quantity * dataToSend.itemListByProduct.productInPriceList.items[j].singlePriceWithoutCurrency).toFixed(2) + " €";
                break;
              }
            }
            if (!itemInserted) {
              dataToSend.itemListByProduct.productInPriceList.items.push(items[i]);
            }
          }
        },

        addItemListByProductNotInPriceList = function(items) {
          var itemInserted = false;
          for (i = 0; i < items.length; i++) {
            for (j = 0; j < dataToSend.itemListByProduct.productNotInPriceList.items.length; j++) {
              itemInserted = false;
              if (dataToSend.itemListByProduct.productNotInPriceList.items[j].productCode == items[i].productCode) {
                itemInserted = true;
                dataToSend.itemListByProduct.productNotInPriceList.items[j].quantity = dataToSend.itemListByProduct.productNotInPriceList.items[j].quantity + items[i].quantity;
                dataToSend.itemListByProduct.productNotInPriceList.items[j].amount = (dataToSend.itemListByProduct.productNotInPriceList.items[j].quantity * dataToSend.itemListByProduct.productNotInPriceList.items[j].singlePriceWithoutCurrency).toFixed(2) + " €";
                break;
              }
            }
            if (!itemInserted) {
              dataToSend.itemListByProduct.productNotInPriceList.items.push(items[i]);
            }
          }
        };

      //window.BticinoS4B.eventAggregator.trigger("modelDeliver:request", this);
      //BticinoS4B.Instances.Models.ApplicationModel.startAutomaticCalculation();

      //Initial datas
      dataToSend.token = window.BticinoS4B.token;
      dataToSend.configuration = {
        fileoutformat: "PDF",
        filerepx: "BTReportThermo001"
      };

      //Header
      dataToSend.header = {
        logo           : "",
        quote_n        : BticinoS4B.Instances.Models.ApplicationModel.get("projectId") ? BticinoS4B.Instances.Models.ApplicationModel.get("projectId") : 0,
        quote_date     : BticinoS4B.Instances.Models.ApplicationModel.get("projectModified") ? moment(BticinoS4B.Instances.Models.ApplicationModel.get("projectModified")).format('L') : moment().format('L'),
        quote_pricelist: $.i18n._("IDS_W1_9076"),
        quote_operator : BticinoS4B.Instances.Models.loginModel.get("username"),
        quote_name     : BticinoS4B.Instances.Models.ApplicationModel.get("projectName") ? BticinoS4B.Instances.Models.ApplicationModel.get("projectName") : "quote",
        quote_note     : BticinoS4B.Instances.Models.ApplicationModel.get("projectNote")   ? BticinoS4B.Instances.Models.ApplicationModel.get("projectNote")   : "",
        quote_ticket   : BticinoS4B.Instances.Models.ApplicationModel.get("projectTicket") ? BticinoS4B.Instances.Models.ApplicationModel.get("projectTicket") : ""
      };

      //Footer
      dataToSend.footer = {};

      //String
      dataToSend.string = {
        "IDS_W1_9021": $.i18n._("IDS_W1_9021"),
        "IDS_W1_9022": $.i18n._("IDS_W1_9022"),
        "IDS_W1_9023": $.i18n._("IDS_W1_9023"),
        "IDS_W1_9024": $.i18n._("IDS_W1_9024"),
        "IDS_W1_9037": $.i18n._("IDS_W1_9037"),
        "IDS_W1_9038": $.i18n._("IDS_W1_9038"),
        "IDS_W1_9039": $.i18n._("IDS_W1_9039"),
        "IDS_W1_9040": $.i18n._("IDS_W1_9040"),
        "IDS_W1_9087": $.i18n._("IDS_W1_9087")
      };

      //ItemListByProduct
      dataToSend.itemListByProduct = {
        productInPriceList: {
          section: $.i18n._("IDS_W1_9034"),
          items: []
        },
        productNotInPriceList: {
          section: $.i18n._("IDS_W1_9094"),
          items: []
        }
      };

      dataToSend.itemListByPackage = {};
      dataToSend.itemListByPackage.externalItems = {};
      dataToSend.itemListByPackage.automaticItems = {};
      dataToSend.itemListByPackage.optionalItems = {};
      dataToSend.itemListByPackage.zones = {};
      //ItemListByPackage
      //dataToSend.itemListByPackage = dataProvider.retrieveMaterialOverviewInReportVersion();

      //var materialList                                         = dataProvider.retrieveMaterialListInReportVersion();
      //dataToSend.itemListByProduct.productInPriceList.items    = materialList.productsInPriceList;
      //dataToSend.itemListByProduct.productNotInPriceList.items = materialList.productsNotInPriceList;

      //Total calculation

      if (window.BticinoS4B.solution.audioVideo.inserted) {
        addItemListByPackageExternalItems(BticinoS4B.modelToExport.audioVideo.itemListByPackage.externalItems);
        addItemListByPackageAutomaticItems(BticinoS4B.modelToExport.audioVideo.itemListByPackage.automaticItems);
        addItemListByPackageOptionalItems(BticinoS4B.modelToExport.audioVideo.itemListByPackage.optionalItems);
        addItemListByPackageZones(BticinoS4B.modelToExport.audioVideo.itemListByPackage.zones);

        addItemListByProductInPriceList(BticinoS4B.modelToExport.audioVideo.itemListByProduct.productInPriceList.items);
        addItemListByProductNotInPriceList(BticinoS4B.modelToExport.audioVideo.itemListByProduct.productNotInPriceList.items);

        grandTotal = grandTotal + BticinoS4B.modelToExport.audioVideo.grandTotal;
      }

      if (window.BticinoS4B.solution.automation.inserted) {
        addItemListByPackageExternalItems(BticinoS4B.modelToExport.automation.itemListByPackage.externalItems);
        addItemListByPackageAutomaticItems(BticinoS4B.modelToExport.automation.itemListByPackage.automaticItems);
        addItemListByPackageOptionalItems(BticinoS4B.modelToExport.automation.itemListByPackage.optionalItems);
        addItemListByPackageZones(BticinoS4B.modelToExport.automation.itemListByPackage.zones);

        addItemListByProductInPriceList(BticinoS4B.modelToExport.automation.itemListByProduct.productInPriceList.items);
        addItemListByProductNotInPriceList(BticinoS4B.modelToExport.automation.itemListByProduct.productNotInPriceList.items);

        grandTotal = grandTotal + BticinoS4B.modelToExport.automation.grandTotal;
      }

      if (window.BticinoS4B.solution.intrusionDetection.inserted) {
        addItemListByPackageExternalItems(BticinoS4B.modelToExport.intrusionDetection.itemListByPackage.externalItems);
        addItemListByPackageAutomaticItems(BticinoS4B.modelToExport.intrusionDetection.itemListByPackage.automaticItems);
        addItemListByPackageOptionalItems(BticinoS4B.modelToExport.intrusionDetection.itemListByPackage.optionalItems);
        addItemListByPackageZones(BticinoS4B.modelToExport.intrusionDetection.itemListByPackage.zones);

        addItemListByProductInPriceList(BticinoS4B.modelToExport.intrusionDetection.itemListByProduct.productInPriceList.items);
        addItemListByProductNotInPriceList(BticinoS4B.modelToExport.intrusionDetection.itemListByProduct.productNotInPriceList.items);

        grandTotal = grandTotal + BticinoS4B.modelToExport.intrusionDetection.grandTotal;
      }

      if (window.BticinoS4B.solution.thermoregulation.inserted) {
        addItemListByPackageExternalItems(BticinoS4B.modelToExport.thermoregulation.itemListByPackage.externalItems);
        addItemListByPackageAutomaticItems(BticinoS4B.modelToExport.thermoregulation.itemListByPackage.automaticItems);
        addItemListByPackageOptionalItems(BticinoS4B.modelToExport.thermoregulation.itemListByPackage.optionalItems);
        addItemListByPackageZones(BticinoS4B.modelToExport.thermoregulation.itemListByPackage.zones);

        addItemListByProductInPriceList(BticinoS4B.modelToExport.thermoregulation.itemListByProduct.productInPriceList.items);
        addItemListByProductNotInPriceList(BticinoS4B.modelToExport.thermoregulation.itemListByProduct.productNotInPriceList.items);
        grandTotal = grandTotal + BticinoS4B.modelToExport.thermoregulation.grandTotal;
      }



      dataToSend.generic = {
        estimateAmount: grandTotal.toFixed(2) + " €"
      };

      $.ajax({
        type: "POST",
        datatype: "json",
        contentType: "application/json",
        url: "/btreport/JSonInterface.asmx/JSonMakeReportThermo",
        data: JSON.stringify(dataToSend),
        success: function(data) {
          var pdfUrl = data.d.fileUrl;
          addDownloadView(pdfUrl);
        },
        error: function(e) {
          this.loaderPopup.hide();
        }
      });

    };

    return exportSolutionMaterialList;

  });